import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import NavDropdown from "react-bootstrap/NavDropdown";
//import Stack from "react-bootstrap/Stack";
import { FiMoreVertical } from "react-icons/fi";
import useUser from "../../../hooks/useUser";
import { useEffect } from "react";
import DataUserDropDown from "./DataUserDropDown";
import DataRegisterDropDown from "./DataRegisterDropDown";
import { pinguinoAzulRegistro } from "../../../assets/ImgLinks";

const MyNavbar = ({ section }) => {
  const [dataUser, adminUser] = useUser();
  const idAptos = dataUser.dataID?.idAptos;
  const idCL = dataUser.dataID?.idCL;
  const idMF = dataUser.dataID?.idMF;
  //const isFounded = dataUser.dataRegister.isFounded;

  useEffect(() => {
    if (adminUser.adminSection) console.log("Welcome to admin Section...");

    return;
  }, [adminUser.adminSection, dataUser.registerComplete]);

  return (
    <div className="">
      <Navbar bg="white" expand="lg">
        <Container>
          <Navbar.Brand>
            {dataUser.email !== "default" &&
              dataUser.email &&
              section === "register" && (
                <h5 className="text-primary fs-6">{`Registrando a: ${dataUser.email}`}</h5>
              )}
            {dataUser.email === "default" && section === "register" && (
              <div className="d-flex align-items-center justify-content-center">
                {/* <img
                  style={{ width: "18vw" }}
                  className="rounded"
                  src={pinguinoAzulRegistro}
                  alt="pinguinoAzulRegistro"
                /> */}
                <h3 className="fs-4 text-info ms-3">REGISTRO MINISOLOVE</h3>
              </div>
            )}
            {!dataUser.email && section === "register" && (
              <div className="d-flex align-items-center justify-content-center">
                {/* <img
                  style={{ width: "18vw" }}
                  className="rounded"
                  src={pinguinoAzulRegistro}
                  alt="pinguinoAzulRegistro"
                /> */}
                <h3 className="fs-4 text-info ms-3">REGISTRO MINISOLOVE</h3>
              </div>
            )}
            {section === "Section Admin" && "Section Admin"}
          </Navbar.Brand>
          {/* <Navbar.Toggle
            className="border border-0 d-none"
            aria-controls="basic-navbar-nav"
          >
            <FiMoreVertical />
          </Navbar.Toggle>
          <Navbar.Collapse id="basic-navbar-nav" className="d-none">
            <Nav className="ms-auto opacity-75">
              <Nav.Link href="#/admin">Admin</Nav.Link>
              <NavDropdown title="Datos Usuario" id="basic-nav-dropdown">
                <DataUserDropDown dataUser={dataUser} />
              </NavDropdown>
              <NavDropdown title="Datos Registro" id="basic-nav-dropdown">
                <DataRegisterDropDown
                  idAptos={idAptos}
                  idCL={idCL}
                  idMF={idMF}
                />
              </NavDropdown>
            </Nav>
          </Navbar.Collapse> */}
        </Container>
      </Navbar>
    </div>
  );
};
export default MyNavbar;
